import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import Github from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>Sahil Thakur</span>
        <div className="f-icons">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/gndec_?igsh=MWY0OG5kczRoNHZ0cg=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <Insta color="white" size={"3rem"} />
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/in/sahil-thakur-1a45b4208?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin color="white" size={"3rem"} />
          </a>

          {/* GitHub */}
          <a
            href="https://github.com/sahilthakur485"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Github color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
